// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addParam {
    justify-content: flex-end;
}

.editor {
    width: 400px;
    height: 300px;
}

.paramTB {
    flex: 1 1 auto;
    margin: 0px 4px;
}

.opRadioB {
    margin: 0px 10px 10px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/python/python.settings.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".addParam {\n    justify-content: flex-end;\n}\n\n.editor {\n    width: 400px;\n    height: 300px;\n}\n\n.paramTB {\n    flex: 1 1 auto;\n    margin: 0px 4px;\n}\n\n.opRadioB {\n    margin: 0px 10px 10px 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
